import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
}), 'SwapHoriz');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SwapHoriz.js
// module id = 6603
// module chunks = 2